<template>
  <div class="flex h-full flex-col">
    <categories-menu />
    <div class="grow overflow-hidden">
      <products-list />
    </div>
    <action-buttons />
  </div>
</template>

<script>
import CategoriesMenu from "@/components/Menu/CategoriesMenu";
import ProductsList from "@/components/Menu/ProductsList";
import ActionButtons from "@/components/Menu/ActionButtons";

export default {
  name: "MenuView",
  components: { ActionButtons, ProductsList, CategoriesMenu },
};
</script>

<style scoped></style>
